import { useEffect, useState } from "react";

export function useHighlightFade(active: boolean, durationMs = 5000): boolean {
  const [visible, setVisible] = useState(false);

  useEffect(
    function syncHighlight() {
      if (!active) {
        setVisible(false);
        return;
      }
      setVisible(true);
      const timer = setTimeout(function hideHighlight() {
        setVisible(false);
      }, durationMs);
      return function cleanup() {
        clearTimeout(timer);
      };
    },
    [active, durationMs],
  );

  return visible;
}
